import React from "react";
import axios from "axios";
import "./SearchResult.css";

export const SearchResult = ({ result, onResultClick, clearInput }) => {
  const host = process.env.REACT_APP_HOST;
  /**
   * this function uses the keywords array to send a request to the backend and return the filtered data
   */
  const handleResultClick = () => {
    axios
      .post(`${host}/paper`, { keywords: [result] })
      .then((response) => {
        // Check if onResultClick is a function before calling it
        if (typeof onResultClick === "function") {
          onResultClick(response.data);
        } else {
          console.error("onResultClick is not a function");
        }

        if (typeof clearInput === "function") {
          clearInput();
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  return (
    <div className="search-result" onClick={handleResultClick}>
      {result}
    </div>
  );
};
